"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenScriptsRequestToJSON = exports.GenScriptsRequestFromJSONTyped = exports.GenScriptsRequestFromJSON = exports.instanceOfGenScriptsRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GenScriptsRequest interface.
 */
function instanceOfGenScriptsRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "brandName" in value;
    isInstance = isInstance && "adCategory" in value;
    isInstance = isInstance && "talkingPoints" in value;
    isInstance = isInstance && "callToAction" in value;
    return isInstance;
}
exports.instanceOfGenScriptsRequest = instanceOfGenScriptsRequest;
function GenScriptsRequestFromJSON(json) {
    return GenScriptsRequestFromJSONTyped(json, false);
}
exports.GenScriptsRequestFromJSON = GenScriptsRequestFromJSON;
function GenScriptsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brandName': json['brand_name'],
        'adCategory': json['ad_category'],
        'talkingPoints': json['talking_points'],
        'phrasesToInclude': !(0, runtime_1.exists)(json, 'phrases_to_include') ? undefined : json['phrases_to_include'],
        'phrasesToExclude': !(0, runtime_1.exists)(json, 'phrases_to_exclude') ? undefined : json['phrases_to_exclude'],
        'callToAction': json['call_to_action'],
        'numberOfScripts': !(0, runtime_1.exists)(json, 'number_of_scripts') ? undefined : json['number_of_scripts'],
    };
}
exports.GenScriptsRequestFromJSONTyped = GenScriptsRequestFromJSONTyped;
function GenScriptsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brand_name': value.brandName,
        'ad_category': value.adCategory,
        'talking_points': value.talkingPoints,
        'phrases_to_include': value.phrasesToInclude,
        'phrases_to_exclude': value.phrasesToExclude,
        'call_to_action': value.callToAction,
        'number_of_scripts': value.numberOfScripts,
    };
}
exports.GenScriptsRequestToJSON = GenScriptsRequestToJSON;
